import * as React from 'react';
import { IListViewFieldColumn } from "../../../../../services/ViewService";
import { Field, FieldGroup, FieldType } from '../../../../../entities/Metadata';
import { ITask } from '../../../../../entities/Subentities';
import { TaskType } from '../../../../../entities/common';

export const TaskTypeFakeField: Field = {
    id: "b3f4a9c2-6d21-4e8b-9a77-0f5c1e2d3b44",
    label: "Task Type",
    name: "taskType",
    type: FieldType.Integer,
    isNative: false,
    isCustom: false,
    isReadonly: true,
    isSystem: false,
    isFake: true,
    group: FieldGroup.SystemFields,
    description: "Task Type defines how Duration, Effort, and assignment units relate for PPM Express tasks. "
        + "Flexible fields are independent; Fixed Units keeps assignment units fixed and recalculates Effort and Duration.",
    settings: {
        views: { list: { componentPath: "task/TaskType", maxWidth: 170 } }
    },
};

export const TaskTypeNames = {
    [TaskType.Flexible]: "Flexible",
    [TaskType.FixedUnits]: "Fixed Units"
};

export default class TaskTypeColumn extends React.Component<IListViewFieldColumn<ITask>> {
    render() {
        const { entity } = this.props;
        return <>{TaskTypeNames[entity.taskType ?? TaskType.Flexible]}</>;
    }
}

export const getValue = (item: ITask) => item.taskType;
export const getSearchValue = (item: ITask) => TaskTypeNames[item.taskType ?? TaskType.Flexible];
